import base from './base'

const getBrokers = () => base
  .get('/brokers/').then(resp => resp.data)

export default {
  getBrokers: getBrokers,
}
